import { VideoPage } from "@/pages/Gallery";
import { IMG } from "@/lib/catalog";

export default function Testimonials() {
  return (
    <VideoPage category="testimonio" seoTitle="Testimonios de clientes" seoDesc="Videos de testimonios de clientes del Taller de Suspensiones La Gringa en Mérida."
      eyebrow="Testimonios" title="Testimonios de clientes" image={IMG.bay}
      subtitle="Escucha lo que dicen nuestros clientes después de reparar su vehículo con nosotros."
      empty="Muy pronto compartiremos aquí los testimonios de nuestros clientes." />
  );
}
